import { render } from "./selectAnagraficaModal.vue?vue&type=template&id=a7c74ba8&ts=true"
import script from "./selectAnagraficaModal.vue?vue&type=script&lang=ts"
export * from "./selectAnagraficaModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__